import { useNavigate } from "react-router-dom";
import React from "react";

const Start_Main_Start_Button = (props) => {
    const {path,classButton,image,classText,text} = props;
    let navigate = useNavigate();
    const handleClick = () => {
        navigate(path);
    }
    return(
        <button className={`start_main_start_button ${classButton}`} onClick={handleClick}>
            {image}
            <span className={classText}>{text}</span>
        </button>
    )
}

export default Start_Main_Start_Button;